class HeaderSearch {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                // TODO ALD CLEAN AFTER DECISION
                Alpine.data("alpinePage", () => ({
                    showForm: false,
                    throttle: false,
                    header: null,
                    anchorTop: null,
                    headerList: null,
                    headings: [],
                    form: null,
                    lastScroll: 0,

                    init() {
                        this.scrollHandler();
                    },
                    scrollHandler() {
                        this.header = document.querySelector(
                            "header:first-of-type",
                        );

                        this.headings = Array.from(
                            document.querySelectorAll(
                                "[data-intersect-heading]",
                            ),
                        ).reverse();

                        this.form = document.querySelector(
                            "[data-intersect-form]",
                        );

                        this.anchorTop = document.querySelector("#anchor_top");

                        this.headerList =
                            document.querySelector("#header_list");

                        this.headingHandler();
                        window.addEventListener("scroll", () =>
                            this.throttleHandler(),
                        );
                    },
                    throttleHandler() {
                        if (this.throttle) {
                            return;
                        }

                        this.headingHandler();
                        this.lastScroll = window.scrollY;
                        this.throttle = true;

                        setTimeout(() => {
                            this.throttle = false;
                            if (this.lastScroll !== window.scrollY) {
                                this.throttleHandler();
                            }
                        }, 250);
                    },
                    headingHandler() {
                        const headerHeight = this.header.clientHeight ?? 0;

                        // anchor top
                        if (window.scrollY === 0) {
                            this.anchorTop.dataset.hidden = true;
                        } else {
                            delete this.anchorTop.dataset.hidden;
                        }

                        // form
                        const formTargetRect =
                            this.form.getBoundingClientRect();
                        this.showForm = formTargetRect.top <= headerHeight;

                        // header list scroll
                        for (const heading of this.headings) {
                            const targetRect = heading.getBoundingClientRect();
                            const label = heading.dataset.label;
                            if (targetRect.top <= headerHeight) {
                                if (heading.dataset.end) {
                                    this.headerList.dataset.hide = true;
                                    return;
                                }
                                this.headerList.innerText = label;
                                delete this.headerList.dataset.hide;
                                return;
                            }
                        }

                        this.headerList.dataset.hide = true;
                    },
                }));
            },
            { once: true },
        );
    }
}

new HeaderSearch();
